import type { IInstitutionContact } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { assignIn } from 'lodash';
import { InstitutionContactViewModel } from 'src/app/business/institution/view-model/institution-contact-view-model';
import { InstitutionContactDB } from 'src/app/common/repository/databases';
import { InstitutionContactFunctionService } from 'src/app/shared/services/institution-contact-function.service';
import { QueryService } from 'src/app/shared/services/query/query.service';

@Injectable({
  providedIn: 'root',
})
export class InstitutionContactService {
  constructor(
    private _queryService: QueryService,
    private _institutionContactFunctionService: InstitutionContactFunctionService
  ) {}

  public async loadInstitutionContacts(institutionId: string): Promise<InstitutionContactViewModel[]> {
    if (!institutionId) {
      return;
    }
    const institutionContactDtos = await this._queryService.search<IInstitutionContact>(
      { query: `institutionId:${institutionId}` },
      InstitutionContactDB
    );

    const contactViewModels = [];
    for (const institutionContactDto of institutionContactDtos) {
      const institutionContactViewModel = await this.createInstitutionContactViewModel(institutionContactDto);
      contactViewModels.push(institutionContactViewModel);
    }

    return contactViewModels.length
      ? contactViewModels.sort((contact1, contact2) => contact1.lastName?.localeCompare(contact2.lastName))
      : [];
  }

  public async loadInstitutionContact(contactId: string): Promise<InstitutionContactViewModel> {
    if (!contactId) {
      return;
    }
    const institutionContactDto = await this._queryService.get<IInstitutionContact>(contactId, InstitutionContactDB);
    if (!institutionContactDto) {
      return;
    }

    return this.createInstitutionContactViewModel(institutionContactDto);
  }

  private async createInstitutionContactViewModel(institutionContactDto: IInstitutionContact) {
    const institutionContactViewModel = new InstitutionContactViewModel();
    assignIn(institutionContactViewModel, institutionContactDto);
    await institutionContactViewModel.loadFunctionName(this._institutionContactFunctionService);

    return institutionContactViewModel;
  }
}
